import React from "react";

import { Col, Form, Row } from "react-bootstrap";

import { Control, Controller, FieldErrors } from "react-hook-form";

import { FormErrorText } from "@components/form/FormErrorText";

import { UserDetailsInput } from "../RegisterFormTypes";

interface DomesticBankDetailsProps {
  control: Control<UserDetailsInput>;
  errors?: FieldErrors<UserDetailsInput>;
}

export const DomesticBankDetails = ({ control, errors }: DomesticBankDetailsProps) => {
  return (
    <>
      <Row>
        <Col md={12} sm={12}>
          <Form.Group>
            <Form.Label>Account name</Form.Label>
            <Controller
              name="bank_details.account_name"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter account name"
                  isInvalid={!!errors?.bank_details?.account_name}
                />
              )}
            />
            <FormErrorText error={errors?.bank_details?.account_name} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6} sm={12}>
          <Form.Group>
            <Form.Label>BSB</Form.Label>
            <Controller
              name="bank_details.bsb"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter BSB"
                  isInvalid={!!errors?.bank_details?.bsb}
                  onKeyDown={(e) =>
                    !(
                      !Number.isNaN(parseInt(e.key)) ||
                      e.key === "Backspace" ||
                      e.key === "ArrowRight" ||
                      e.key === "ArrowLeft" ||
                      e.key === "Tab" ||
                      e.key === "Shift" ||
                      e.key === "Enter"
                    ) && e.preventDefault()
                  }
                />
              )}
            />
            <FormErrorText error={errors?.bank_details?.bsb} />
          </Form.Group>
        </Col>
        <Col md={6} sm={12}>
          <Form.Group>
            <Form.Label>Account number</Form.Label>
            <Controller
              name="bank_details.account_number"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  type="text"
                  placeholder="Enter account number"
                  isInvalid={!!errors?.bank_details?.account_number}
                />
              )}
            />
            <FormErrorText error={errors?.bank_details?.account_number} />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
